/**
 * Node Modules
 */
import React from 'react'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'
import Logo from '../../elements/logo'
import NavigationOverlay from '../navigation-overlay'

/**
 * Component
 */
export default function Header({ styles, children }) {
  return (
    <header className="header" style={styles}>
      <div className="header__grid grid">
        <div className="header__logo-group column-start-1 column-end-2 flex">
          <Link className="header__logo-link" to="/">
            <Logo className="header__logo" alt="Kinzoo" aria-label="Kinzoo" />
          </Link>
          {children}
        </div>

        <nav className="header__nav column-start-4 column-end-12--t">
          <ul className="header__nav-list">
            <li className="header__nav-item">
              <Link className="header__nav-link" to="/about">
                About Us
              </Link>
              <div className="header__sub-nav-group ">
                <ul className="header__sub-nav">
                  <li className="header__sub-nav-item">
                    <Link
                      className="header__sub-nav-link"
                      to="/life-at-kinzoo"
                      activeClassName="active"
                    >
                      Life at Kinzoo
                    </Link>
                  </li>
                  <li className="header__sub-nav-item">
                    <Link
                      className="header__sub-nav-link"
                      to="/our-values"
                      activeClassName="active"
                    >
                      Our Values
                    </Link>
                  </li>

                  <li className="header__sub-nav-item">
                    <Link className="header__sub-nav-link" to="/our-story" activeClassName="active">
                      Our Story
                    </Link>
                  </li>
                  <li className="header__sub-nav-item">
                    <Link
                      className="header__sub-nav-link"
                      to="/community-guidelines"
                      activeClassName="active"
                    >
                      Community Guidelines
                    </Link>
                  </li>

                  {/*             <li className="header__nav-item">
              <Link className="header__nav-link" to="/life-at-kinzoo">
                Life at Kinzoo
              </Link>
            </li>
                  <li className="header__sub-nav-item">
                    <Link className="header__sub-nav-link" to="/" activeClassName="active">
                      Link C
                    </Link>
                  </li> */}
                </ul>
              </div>
            </li>

            <li className="header__nav-item">
              <Link className="header__nav-link" to="/get-involved">
                Get Involved
              </Link>
            </li>
            <li className="header__nav-item">
              <Link className="header__nav-link" to="/press-release">
                Press
              </Link>
            </li>
            <li className="header__nav-item">
              <Link className="header__nav-link" to="/blog">
                Blog
              </Link>
            </li>
            <li className="header__nav-item">
              <Link className="header__nav-link" to="/help-center">
                Help
              </Link>
            </li>
            <li className="header__nav-item">
              <Link className="header__nav-link button button--f1 button--coral header__download-link" activeClassName="hidden" to="/download">
                Download
              </Link>
            </li>
          </ul>
        </nav>

        <div className="header__download column-start-3 column-end-5 column-end-11--t header__download-link"><Link to="/download" activeClassName="hidden">Download</Link></div>

        <NavigationOverlay />
      </div>
    </header>
  )
}
